import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

// components
import Btn from '../../components/Btn';

// actions
import { clearPlacesField } from '../../reducers/Places/actions';

const ClearBtnPropTypes = {
  id: PropTypes.string.isRequired, // Unique identifier of Places input field
  order: PropTypes.number.isRequired, // order of Places input field
  directionsLoaded: PropTypes.bool.isRequired, // If the directions have returned from routing service
  dispatchClearPlacesField: PropTypes.func.isRequired, // Clears text from input field
};

const ClearBtnDefaultProps = {};

class ClearBtn extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { id, order, dispatchClearPlacesField } = this.props;
    dispatchClearPlacesField({ id, order });
  }

  render() {
    const { directionsLoaded } = this.props;

    return (
      <Btn
        styles={classNames('clear-btn', {
          hidden: directionsLoaded,
        })}
        handleClick={this.handleClick}
      >
        <i className="tsla-icon-close--circle" />
      </Btn>
    );
  }
}

ClearBtn.propTypes = ClearBtnPropTypes;

ClearBtn.defaultProps = ClearBtnDefaultProps;

const mapStateToProps = state => ({
  directionsLoaded: state.Directions.directionsLoaded,
});

const mapDispatchToProps = dispatch => ({
  // eslint-disable-next-line arrow-parens
  dispatchClearPlacesField: field => {
    dispatch(clearPlacesField(field));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ClearBtn);
